import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import helpers from '@/helpers'
import axios from 'axios'
// import font from '/@mdi/font'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

import { Settings } from 'luxon'
Settings.defaultLocale = 'pt'

Vue.prototype.$http = axios
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')



